const AGENT_MENTION_REGEX = /(^|[\s,;(>"'<])@sudowrite\b/i;

export const SHARED_REPLY_SIGN_IN_MESSAGE = "Sign in to see this comment.";

export function getRepliesForRendering({ replies, isSharedDocument }) {
  const safeReplies = Array.isArray(replies) ? replies : [];
  if (!isSharedDocument || safeReplies.length === 0) {
    return safeReplies;
  }

  const blockedReplyIndex = safeReplies.findIndex((reply) => {
    const content = typeof reply?.content === "string" ? reply.content : "";
    return AGENT_MENTION_REGEX.test(content);
  });

  if (blockedReplyIndex === -1) {
    return safeReplies;
  }

  const blockedReply = safeReplies[blockedReplyIndex];
  return [
    ...safeReplies.slice(0, blockedReplyIndex),
    {
      ...blockedReply,
      content: SHARED_REPLY_SIGN_IN_MESSAGE,
      _sharedCommentPreviewGate: true,
    },
  ];
}
